
import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: (builder) => ({
        getUserProfile: builder.mutation({
            query: (body = {}) => ({
                url: "admin/getUserProfile",
                method: "POST",
                body,
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getAdminLogout: builder.mutation({
            query: (body = {}) => ({
                url: "admin/logout",
                method: "POST",
                body,
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
    }),
});

export const {
    useGetUserProfileMutation,
    useGetAdminLogoutMutation,
} = Api;
